/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import { FC, useContext, useEffect, useState } from 'react';

import 'react-quill-new/dist/quill.snow.css';

import { ContentfulEntry } from 'blades/widgetTypes';
import DateTimeRenderer from '../DateTime/dateTime';
import { useIsMobileViewport, useIsTabletViewport } from '../../hooks/useIsMobileViewport';

import AuthContext from '../../AppContext/AuthProvider';
import { CType } from '../../models/Contentful/types';
import GotSubmission from '../Messages/GotSubmission';
import {
  IContentfulInformativeModal,
  IInformativeModalProps,
} from '../../blades/informativeModal/@types';
import { ISkillbuilderProps } from '../../models/SkillBuilder/@types';
import ImageComponent from '../Image';
import InformativeModal from '../../blades/informativeModal/informativeModal';
import RichText from '../RichText';
import SectionWrapper from '../SectionWrapper';
import SkillbuilderSubmissionForm from '../SkillbuilderSubmissionForm';
import SvgLib from '../SvgLib';
import Typo from '../Typo';
import VideoPlayer from '../VideoPlayer';
import Widgets from '../../blades/Widgets';
import contentfulClient from '../../models/Contentful';
import styles from './skillbuilderdetail.module.sass';
import useSkillBuilderActions from './useSkillBuilderAction';

const SkillBuilderDetail: FC<ISkillbuilderProps> = props => {
  const {
    widget,
    title,
    description,
    image,
    videoUrl,
    // skillName,
    // industry,
    skills,
    industryList,
    award,
    earnPoints,
    duration,
    partners,
    // modals,
    launchedDate,
    slug,
    entryId,
  } = props;

  const industry = industryList?.fields?.title?.join(', ');
  const skillNames = skills?.fields?.title ?? [];
  const { isTablet } = useIsTabletViewport();
  const { appUser } = useContext(AuthContext);
  const [createAccountModal, setCreateAccountModal] = useState<CType<IInformativeModalProps>>();

  useEffect(() => {
    const fetchCreateAccountModal = async () => {
      const response = await contentfulClient.getEntries<
        ContentfulEntry<IContentfulInformativeModal>
      >({
        content_type: 'informativeModal',
        'fields.type[in]': ['Skillbuilder PopUp'],
        'fields.subType': 'Create Account',
        include: 10,
      } as any);
      const createAccountModal = response.items.find(m => m?.fields?.subType === 'Create Account');
      response && setCreateAccountModal(createAccountModal as CType<IInformativeModalProps>);
    };
    fetchCreateAccountModal();
  }, []);

  const scrollToSubmission = () => {
    if (document !== null) {
      const SkillbuilderSubmissionDiv = document.getElementById('submissionDivId');
      if (!isMobile) {
        window.scrollTo({
          top: SkillbuilderSubmissionDiv?.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  };

  const { isMobile } = useIsMobileViewport();
  const { modalData, hasParticipated, setHasParticipated } = useSkillBuilderActions(
    entryId ?? slug ?? '',
  );
  return (
    <>
      <div className={styles.wrapper}>
        <SectionWrapper>
          <div className={styles.root}>
            <div>
              <div className="mb-2">
                <Typo normal>{industry}</Typo>
              </div>
              <div className={`${styles.borderBox} mb-4`}>
                <Typo normal bold classes="is-color-Purple mr-1 mb-1">
                  Skillbuilder:
                </Typo>
                {skillNames.length &&
                  skillNames.map((skill, index) => {
                    return (
                      <Typo normal bold classes="is-color-Purple mr-1 mb-1">
                        {index === skillNames.length - 1 ? `${skill}` : `${skill},`}
                      </Typo>
                    );
                  })}
              </div>
              <div className="mb-2">
                <Typo h1 classes={'is-size-2'}>
                  {title}
                </Typo>
              </div>
              <div className="mb-4">
                <Typo small classes="is-color-BlackHalf">{`Effort: ${duration}`}</Typo>
              </div>
              <div
                className={`is-flex mb-5 ${
                  isTablet && 'is-justify-content-center is-flex-wrap-wrap'
                }`}
              >
                <div
                  className={`is-flex is-flex-direction-column ${
                    isTablet ? 'mr-4 has-text-left ' : 'mr-6'
                  }`}
                >
                  <Typo normal>Earns</Typo>
                  <div className="is-flex is-align-items-center">
                    <SvgLib icon="earned" iconSize="Medium" color="black" />
                    <Typo classes={'is-size-3'}>{`+${earnPoints} Points`}</Typo>
                  </div>
                </div>
                {award && (
                  <div
                    className={`is-flex is-flex-direction-column ${
                      isTablet ? 'has-text-left' : ''
                    }`}
                  >
                    <Typo normal>Winner</Typo>
                    <div className="is-flex is-align-items-center ">
                      <SvgLib icon="winner" iconSize="Medium" color="black" />
                      <Typo classes="ml-2 is-size-3">{award}</Typo>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div>
              <div>
                <DateTimeRenderer
                  date={launchedDate}
                  typoClasses={`is-color-BlackHalf mb-2 ${isMobile ? 'h4' : 'small'}`}
                  textBefore="Launched "
                />
              </div>
              {!videoUrl ? (
                <div className={styles.imageComponent}>
                  <ImageComponent image={image} aspectRatio="16/9" classes="is-borderBox1" />
                </div>
              ) : (
                <VideoPlayer videoUrl={videoUrl} classes="is-borderBox1" />
              )}
            </div>
          </div>
        </SectionWrapper>
        <Widgets widget={widget} />
      </div>
      <div id="submissionDivId">
        <SectionWrapper>
          <div className={styles.root}>
            <div>
              <div>
                <Typo normal>
                  <RichText document={description} />
                </Typo>
              </div>
              <div className="mt-4 mb-6 has-text-left">
                <Typo normal>Sponsored by</Typo>
                <div className="is-flex ">
                  {partners &&
                    partners.map((partner, index) => {
                      return (
                        index < 3 && (
                          <ImageComponent
                            image={partner.fields.image}
                            width={isTablet ? '75px' : '60px'}
                            height={isTablet ? '55px' : '60px'}
                          />
                        )
                      );
                    })}
                </div>
              </div>
            </div>
            <div>
              {!appUser ? (
                createAccountModal && <InformativeModal {...createAccountModal} />
              ) : (
                <>
                  <div
                    style={{
                      display: `${hasParticipated ? '' : 'none'}`,
                    }}
                  >
                    <GotSubmission
                      {...modalData}
                      skillbuilderId={entryId ?? slug ?? ''}
                      userId={appUser.id}
                    />
                  </div>
                  <div
                    style={{
                      display: `${!hasParticipated ? '' : 'none'}`,
                    }}
                  >
                    <SkillbuilderSubmissionForm
                      slug={slug}
                      entryId={entryId}
                      earnPoints={earnPoints}
                      setHasParticipated={setHasParticipated}
                      onSubmit={scrollToSubmission}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </SectionWrapper>
      </div>
    </>
  );
};

export default SkillBuilderDetail;
